import { ToastProps } from "@components/toast"
import type { StoreApi } from "zustand"
import { StoreState } from "./types"

export type Toast = Omit<
  ToastProps,
  | "handleRequestClose"
  | "handleClickButton"
  | "isFirstVisible"
  | "index"
  | "isWrapperExpanded"
> & {
  id: string
}

export type State = {
  byId: string[]
  items: {
    [key: string]: Toast
  }
  maxHeight: number
}

export const slice = (
  set: StoreApi<StoreState>["setState"],
  get: StoreApi<StoreState>["getState"],
): State => ({
  byId: [],
  items: {},
  maxHeight: 58, // 58px is the height of a single toast with one line of text
})
